exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2BP1d{background:#f4f8fb}._1BGUJ{width:1180px;margin:50px auto 0}._2Rav6{position:fixed;left:-999px;top:-100px;text-indent:-2000px;overflow:hidden}", ""]);

// exports
exports.locals = {
	"homeWholeContent": "_2BP1d",
	"content": "_1BGUJ",
	"title": "_2Rav6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/home/Home.css
// module id = 1224
// module chunks = 1